/**
 * Internal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedLocationWebsiteDirty from './is-edited-location-website-dirty';
import getLocationWebsite from './get-location-website';
import getEdits from './get-edits';

export default (state, id) => {

    id = !id ? "" : id;

    if (isEditedLocationWebsiteDirty(state, id || "")) {
        let locationWebsite = getLocationWebsite(state, id);
        let edits = getEdits(state, id);
        locationWebsite = applyEdits(locationWebsite, edits);
        return locationWebsite;
    }

    return getLocationWebsite(state, id);
};